<div *ngIf="config" class="pl-carousel relative w-full">
  <div
    class="absolute left-0 top-0 z-10 flex h-full w-12 cursor-pointer select-none items-center justify-center"
    (click)="onPrevButtonClicked()"
  >
    <pl-icon
      [name]="PlIcon.chevron_back"
      [frame]="IconFrame.round"
      class="h-10 w-10 border-transparent bg-pl-gray-300 text-pl-gray-700 hover:bg-gray-400"
    />
  </div>
  <swiper-container plSwiper [config]="config" init="false" class="relative flex w-full bg-pl-gray-100 pt-5 shadow-md">
    <swiper-slide class="px-12 h-auto" [ngClass]="showDots ? 'pb-10' : 'pb-5'" *ngFor="let slide of slidesContent">
      <div [innerHTML]="slide" class="pl-inner-html flex flex-col items-center gap-2 text-center"></div>
    </swiper-slide>
  </swiper-container>
  <div
    class="absolute right-0 top-0 z-10 flex h-full w-12 cursor-pointer select-none items-center justify-center"
    (click)="onNextButtonClicked()"
  >
    <pl-icon
      [name]="PlIcon.chevron_forward"
      [frame]="IconFrame.round"
      class="h-10 w-10 border-transparent bg-pl-gray-300 text-pl-gray-700 hover:bg-gray-400"
    />
  </div>
</div>
